export default __webpack_public_path__ + "static/hipopener_header-e1433f63ed6c15697b184c2ce663d60a.png";